import { useForm, ValidationError } from '@formspree/react';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import './contact.css';

export default function Contact() {

    const { executeRecaptcha } = useGoogleReCaptcha();

    const [state, handleSubmit] = useForm("xdkoeeql", {
        data: { "g-recaptcha-response": executeRecaptcha }
    });

    return (
        <section className="contact-panel" id="contact">
            <div className="inner">
                <div className="cols span-2">
                    <div className="col">
                        <h2>Get in touch</h2>
                        <h3>Let's talk!</h3>
                        <p>Don't like forms? You can email me <a href="mailto:me@callum-tanner.com">here</a> instead!</p>
                    </div>
                    <div className="col">
                        {state.succeeded === true ? <>
                            <h3><strong>Thanks!</strong></h3>
                            <p>I've received your query and will aim to respond in 2-3 days.</p>
                        </> : <form onSubmit={handleSubmit} method="POST">
                            <div className="form-inner">
                                <div className="form-row">
                                    <div className="form-cell">
                                        <label>Name:</label>
                                        <input type="text" name="name" id="name" placeholder="" />

                                        <ValidationError className="form-error" prefix="Name" field="name" errors={state.errors} />
                                    </div>
                                    <div className="form-cell">
                                        <label>Email:</label>
                                        <input type="email" name="email" id="email" placeholder="" />

                                        <ValidationError className="form-error" prefix="Email" field="email" errors={state.errors} />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-cell">
                                        <label>Subject:</label>
                                        <input type="text" name="subject" id="subject" placeholder="" />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-cell">
                                        <label>Message:</label>
                                        <textarea name="message" id="message" placeholder=""></textarea>

                                        <ValidationError className="form-error" prefix="Message" field="message" errors={state.errors} />
                                    </div>
                                </div>

                                <div className="form-row form-row-submit">
                                    <button type="submit" disabled={state.submitting}>Submit</button>
                                </div>
                            </div>
                        </form>}
                    </div>
                </div>
            </div>
        </section>
    );
}